import React from 'react'
import { makeStyles } from '@material-ui/core/styles';
import { red, green } from '@material-ui/core/colors';

const colors = {
    VEG: green[600],
    NON_VEG: red[600],
    CONTAINS_EGG: '#96503a'
}

const useStyles = makeStyles((theme) => ({
    header: {
        position: "relative"
    },
    mark: {
        padding: "0 0 0 20px",
        position: "relative",
        lineHeight: "2",
        color: "#a8a8a8",
        textTransform: "uppercase",
        '&::before': {
            content: '" "',
            position: "absolute",
            width: "14px",
            height: "14px",
            boxSizing: "border-box",
            border: (props) => `1px solid ${colors[props.type]}`,
            borderRadius: "2px",
            left: "0",
            top: "6px",
        },
        '&::after': {
            content: '" "',
            position: "absolute",
            width: "6px",
            height: "6px",
            boxSizing: "border-box",
            background: (props) => colors[props.type],
            borderRadius: "50%",
            left: "4px",
            top: "10px"
        }
    }
}));

const Mark = (props) => {
    const { foodLabel } = props
    const classes = useStyles(props);
    return (
        <div className={classes.header}>
            <div className={classes.mark}> <span>{foodLabel}</span></div>
        </div>
    )
}

export default Mark